import * as React from "react";
import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { Trans, useTranslation } from "react-i18next";
import useProductName from "brand-customization/useProductName";
import { DATA_LAKE_BACKEND_CONFIG_QUERY_KEYS } from "data-lake/Constants";
import useDataLakeConfigMutation from "data-lake/configurations/hooks/useDataLakeConfigMutation";
import { ConfirmDialog, IfPermitted } from "components/common";
import { Alert, Button } from "components/bootstrap";
const DataLakeBackendActivateButton = ({ backend, isActiveBackend, config }) => {
  const { t } = useTranslation("enterprise_data_lake");
  const productName = useProductName();
  const [showModal, setShowModal] = useState(false);
  const { onUpdateDataLakeConfig } = useDataLakeConfigMutation();
  const queryClient = useQueryClient();
  const onModalClose = () => {
    setShowModal(false);
  };
  const onButtonClick = () => {
    setShowModal(true);
  };
  const onConfirm = () => {
    onUpdateDataLakeConfig({ config: { ...config, active_backend: backend.id } }).then(() => {
      queryClient.invalidateQueries({ queryKey: DATA_LAKE_BACKEND_CONFIG_QUERY_KEYS });
      onModalClose();
    });
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, showModal && /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      show: showModal,
      onConfirm,
      onCancel: onModalClose,
      title: t("backend_activate.title")
    },
    /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      Trans,
      {
        t,
        i18nKey: "backend_activate.text",
        values: { title: backend.title },
        components: { bold: /* @__PURE__ */ React.createElement("strong", null) }
      }
    ), !isActiveBackend && /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger" }, /* @__PURE__ */ React.createElement("p", null, t("backend_activate.switch_warning")), /* @__PURE__ */ React.createElement("p", null, t("backend_activate.data_not_moved")), /* @__PURE__ */ React.createElement("p", null, t("backend_activate.only_active_accessible", { productName }))), /* @__PURE__ */ React.createElement("p", null, t("backend_activate.confirm_question")))
  ), !isActiveBackend && /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "data_lake_backend_config:update" }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "default", bsSize: "medium", onClick: onButtonClick }, t("backend_activate.activate_button"))));
};
export default DataLakeBackendActivateButton;
